import * as React from 'react'
import {
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  Labeled,
  RecordContext,
  ReferenceField,
  ReferenceManyField,
  SimpleForm,
  TextField,
  TextInput,
  useRecordContext,
} from 'react-admin'

import { Account, User } from 'shared/types'
import { ComponentWithDynamicResourceHeader } from 'dash/shared/molecules/ComponentWithSubheader'
import { CreateButton } from 'shared/molecules/modal/CreateButton'
import { PageTitle, SaveOnlyToolbar } from 'shared/react-admin'
import { StatusField } from 'dash/resources/user/membership/StatusField'
import { TeamInviteButton } from 'dash/shared/molecules/TeamInviteButton'
import { UserAvatar } from 'shared/atoms/UserAvatar'
import { UserBlock } from 'shared/molecules/UserBlock'
import { Link } from 'react-router-dom'

export const AccountEdit = () => {
  // const validateName = [
  //   (value) => (value.trim().split(' ').length <= 1 ? 'must be at least 2 words (First Last)' : undefined),
  // ];

  return (
    <Edit redirect={false} title={<PageTitle resource="Account" source="name" />}>
      <ComponentWithDynamicResourceHeader recordAttrForBreadrumb="name">
        <SimpleForm redirect="edit" toolbar={<SaveOnlyToolbar />}>
          {/* <TextInput disabled label="Id" source="id" /> */}
          {/* <TextInput source="name" validate={validateName} /> */}
          <TextInput source="name" />
          <TextInput source="billingContactEmail" />
          <AccountSettings />
          {/* <TextInput source="email" validate={email()} /> */}
          {/* <Button label="Change Password" /> */}
          <TeamList />
        </SimpleForm>
      </ComponentWithDynamicResourceHeader>
    </Edit>
  )
}

const AccountSettings = () => {
  const record = useRecordContext()
  return (
    <>
      <p>ACCOUNT SETTINGS</p>
      <ReferenceField source="settings.id" reference="admin/setting" link="">
        <TextInput disabled label="Max Users" source="configuration.max_users" />
      </ReferenceField>
      <ReferenceField source="settings.id" reference="admin/setting" link="">
        <TextInput disabled label="Max Forms" source="configuration.formtopia.max_forms" />
      </ReferenceField>
      <Link to={`/admin/setting/${record.settings?.id}`}>Edit Account Settings</Link>
    </>
  )
}

const TeamList = () => {
  const record = useRecordContext()

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'flex-end',
          marginTop: 8,
          marginLeft: 'auto',
        }}
      >
        <TeamInviteButton accountId={record.id} />
      </div>
      <ReferenceManyField reference="admin/membership" target="accountId" fullWidth>
        <Datagrid>
          <ReferenceField label="User" source="user.id" reference="admin/user" link="">
            <UserBlock label="User" />
          </ReferenceField>
          <StatusField source="status" />
          <DateField source="invitedAt" label="Invited" />
          <ReferenceField label="Invited By" source="invitedBy.id" reference="admin/user" link="">
            <TextField source="name" />
          </ReferenceField>
          <DeleteButton mutationMode="undoable" redirect={null} />
        </Datagrid>
      </ReferenceManyField>
    </>
  )
}
